// Port of api/fuel/app/classes/controller/api/monty/games/search.php
import { buildSearchResponse } from 'offline/api/games/shared'

export default function(params) {
	return buildSearchResponse(params)
}
